// extracted by mini-css-extract-plugin
module.exports = {"arrow":"mAsLZZvr _26cqdtFW","largeArrow":"_3gAo5S0F","arrowIcon":"_1jNkASx0 _3Cc7EQMK","productImageContainer":"_2w1kJ9dX","productImage":"_1UEcOIuZ"};